export default __webpack_public_path__ + "static/media/google-review.6f5d8972.svg";